import { default as MuiStepConnector } from '@mui/material/StepConnector';

/**
 * StepConnector renders the connector line between Stepper steps.
 *
 * Demos:
 *
 * - [Stepper](https://unify.workiva.org/components/stepper?tab=code)
 *
 * API:
 *
 * - [StepConnector API](https://unify.workiva.org/components/stepper?tab=props#stepconnector)
 */
export const StepConnector = MuiStepConnector;
export {
  type StepConnectorProps,
  stepConnectorClasses,
} from '@mui/material/StepConnector';
